

import Vue from 'vue';
import NOC from '@/class/common/const';

export default Vue.extend({
  name: 'Contact',
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  created() {
    if (process.env.VUE_APP_MODE === 'PROD') {
      window.location.replace('/service/contact#form');
    } else {
      window.location.replace('/Login');
    }
  },
});
